
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/shareWith/guestSelect',['Vue','vuex', 'vue!../../reusableComponents/dropdown'],function(Vue,vuex, dropdown){
        return {
            name:'guestSelect',
            template:template,
            components: {
                dropdown: dropdown
            },
             computed: _.extend(vuex.mapState('pmsCheckin', ['shareWith','pmsBookingInfo']),{
                groupMembers: function() {
                    var vm = this;
                    return this.$store.getters['pmsCheckin/groupMembers'].map(function(gm){
                        var disable = !!vm.$store.state.pmsCheckin.shareWith[gm.CustomerId]
                        return {text: gm.displayName, val: gm, disable: disable};
                    });
                },
                selectedGuests: function () {
                    return Object.keys(this.shareWith).length
                },
                isAllowedMore: function () {
                   return +this.selectedGuests < +this.pmsBookingInfo.numOfGuests
                }
            }),
            methods: {
                handleOptionClick: function(e, option) {
                    e.preventDefault();
                    if(option.disable) return;
                    this.$store.commit('pmsCheckin/addShareWith', option.val);
                },
                handleTrailingOptionClick: function(e) {
                    e.preventDefault();
                    this.$emit('handleTrailingOptionClick', true);
                }
            }
        }
    })
})('<div> <dropdown v-if="isAllowedMore" :options="groupMembers" :handleOptionClick="handleOptionClick" :trailing="localization.eReg.addNewGuestLabel" :handleTrailingOptionClick="handleTrailingOptionClick"> <template v-slot:icon> <div class="dropdownHeader"> <span>{{localization.eReg.addNewGuestLabel}}</span> <i class="fas fa-angle-down"></i> </div> </template> </dropdown> <p class="allowedGuestsError" v-else>Cannot add more than {{selectedGuests}} guest(s)</p> </div>');
